// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-row{display:flex}.table-row-left,.table-row-right{height:28px}.table-row-left{background:#f7bcbc;color:#fff;flex:1.5;position:relative}.table-row-right{background:#fdf1f1;flex:1}.table-row-left:after{content:\"\";display:block;width:0;height:0;position:absolute;top:0;left:100%;border-color:transparent transparent transparent #f7bcbc;border-style:solid;border-width:14px 0 14px 10px}", ""]);
// Exports
module.exports = exports;
